export default __webpack_public_path__ + "static/media/title05.95eb969a.png";